
const HOST = 'https://api.relaxplay.net/';
// const HOST = "https://api.x-players.com/";
const API_HOST = `${HOST}api/`;
const RESELLER_PANEL = "https://reseller.relaxplay.net/"

export { HOST, API_HOST, RESELLER_PANEL };